import { useTranslation } from 'services/hooks';
import './style.css';

export default function UnsupportedFile({ linkToDisplay }) {
	const getTranslation = useTranslation();

	const TRANSLATION_KEY = 'unsupported_file';

	return (
		<p className="UnsupportedFile">
			<div className="UnsupportedFile__logo"></div>
			<p
				dangerouslySetInnerHTML={{
					__html: getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_file_text`)?.replace('[linkToDisplay]', linkToDisplay),
				}}
			></p>
		</p>
	);
}
